var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2F3C",
    d: "M15.687 8.313H7.678l7.587-2.004a.56.56 0 0 0 .4-.692l-.574-2.109a1.12 1.12 0 0 0-1.365-.783L3.018 5.552a1.107 1.107 0 0 0-.791 1.364l.523 1.928v6.219a1.125 1.125 0 0 0 1.125 1.124h11.25a1.125 1.125 0 0 0 1.125-1.125V8.875a.56.56 0 0 0-.563-.562m-1.676-4.5.422 1.551-1.59.422-1.978-1.142zM9.321 5.05 11.3 6.192l-2.597.685-1.977-1.14zM3.74 8.187l-.422-1.552 1.864-.492 1.977 1.143zm11.386 6.876H3.875V9.436h11.25z"
  })));
};
export default SvgFilm;